module.exports = __webpack_public_path__ + "img/image6.d8e269d7.jpg";